export default __webpack_public_path__ + "static/sm-poster01-2a417123b20b0653612fe6c122e99954.png";